import React, { createContext, useContext, useState, useCallback } from 'react';

// ════════════════════════════════════════════════════════════════════════════
// ToastContext.jsx — r87 (Rodada C)
// ────────────────────────────────────────────────────────────────────────────
// Sistema simples de toast notifications.
// USO:
//   const { mostrarToast } = useToast();
//   mostrarToast('Sem permissão', 'erro');  // tipos: 'erro' | 'sucesso' | 'info'
//
// Auto-fecha em 3s. Empilha múltiplos no canto inferior direito.
// ════════════════════════════════════════════════════════════════════════════

const ToastContext = createContext(null);

const CORES = {
  erro:    { bg: '#fee2e2', borda: '#dc2626', texto: '#991b1b' },
  sucesso: { bg: '#ecfdf5', borda: '#1D9E75', texto: '#065f46' },
  info:    { bg: '#eff6ff', borda: '#003399', texto: '#1e3a8a' },
};

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const mostrarToast = useCallback((mensagem, tipo = 'info', duracaoMs = 3500) => {
    const id = `t_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
    setToasts(prev => [...prev, { id, mensagem, tipo }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, duracaoMs);
  }, []);

  const fechar = (id) => setToasts(prev => prev.filter(t => t.id !== id));

  return (
    <ToastContext.Provider value={{ mostrarToast }}>
      {children}

      {/* Container fixo */}
      <div style={{
        position: 'fixed', bottom: 20, right: 20,
        display: 'flex', flexDirection: 'column', gap: 8,
        zIndex: 9999, maxWidth: 380, fontFamily: "'Manrope', sans-serif",
      }}>
        {toasts.map(t => {
          const c = CORES[t.tipo] || CORES.info;
          return (
            <div key={t.id} style={{
              backgroundColor: c.bg,
              border: `1px solid ${c.borda}`,
              borderLeft: `4px solid ${c.borda}`,
              color: c.texto,
              padding: '10px 14px',
              borderRadius: 6,
              fontSize: 13,
              boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
              display: 'flex',
              alignItems: 'flex-start',
              gap: 10,
              animation: 'slideIn 0.2s ease-out',
            }}>
              <span style={{ flex: 1, lineHeight: 1.4 }}>{t.mensagem}</span>
              <button onClick={() => fechar(t.id)} style={{
                background: 'transparent', border: 'none',
                color: c.texto, cursor: 'pointer',
                fontSize: 16, lineHeight: 1, padding: 0,
                opacity: 0.6,
              }}>×</button>
            </div>
          );
        })}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast precisa estar dentro de <ToastProvider>');
  return ctx;
}
